import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { Tooltip } from '@mui/material';
import { Permissions } from '../permissions';
import { getSelectedUserType } from 'store/selectors/selectors';
import { useTranslation } from 'react-i18next';

type PermissionKey = keyof typeof Permissions;

interface PermissionGuardProps {
  permission: PermissionKey;
  children: ReactNode;
  tooltipText?: string;
  showTooltip?: boolean;
  selectedUserType: string;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  children,
  tooltipText,
  showTooltip = true,
  selectedUserType,
}) => {
  const { t } = useTranslation(['common']);
  const requiredRoles = Permissions[permission] || [];
  const tooltip = tooltipText ?? t('common:permissions:InsufficientPermissions')!;
  const hasAccess = requiredRoles.includes(selectedUserType);

  return hasAccess ? (
    <>{children}</>
  ) : showTooltip ? (
    <Tooltip title={tooltip} arrow>
      <span>{React.cloneElement(children as React.ReactElement, { disabled: true })}</span>
    </Tooltip>
  ) : (
    React.cloneElement(children as React.ReactElement, { disabled: true })
  );
};

const mapStateToProps = (state: any) => ({
  selectedUserType: getSelectedUserType(state),
});

export default connect(mapStateToProps)(PermissionGuard);
